import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=060c6d2d&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"
import style0 from "./Files.vue?vue&type=style&index=0&id=060c6d2d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060c6d2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('060c6d2d')) {
      api.createRecord('060c6d2d', component.options)
    } else {
      api.reload('060c6d2d', component.options)
    }
    module.hot.accept("./Files.vue?vue&type=template&id=060c6d2d&scoped=true", function () {
      api.rerender('060c6d2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Files.vue"
export default component.exports